export default __webpack_public_path__ + "static/media/SZ05.39962ba1.mp3";